import { render, staticRenderFns } from "./RoomImage.vue?vue&type=template&id=2529aa38"
import script from "./RoomImage.vue?vue&type=script&lang=js"
export * from "./RoomImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports